export default bp => ["xs", "sm"].includes(bp);
